import React from "react";
import Layout from "../../components/user/Layout";
import ProductDetails from "../../components/user/ProductDetails";
import { useParams } from "react-router-dom"
import ShopSection from "../../components/ShopSection";
import CategoryProductList from "../../components/user/CategoryProductList";

const AllCategoryProductListPage = () => {
    const { categoryID } = useParams();
    return (
        <>
            <Layout>

                <CategoryProductList categoryID={categoryID} />
            </Layout>

        </>
    );
}

export default AllCategoryProductListPage;